export function formatMoney(n:number){
    if(!n) return 'R$ 0,00';
    return "R$ " + n.toFixed(2).replace(/\./, ',').replace(/(\d+)(\d{3}),/, "$1.$2,")
}

export function bigNumber(n:number){
    if(n == null) return "";
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function decimal(n:number, decimalPlaces = 1){
    if(n == null) return "";
    const f = new Intl.NumberFormat('pt-BR', {maximumFractionDigits: decimalPlaces});
    return f.format(n);
}